import apiClient from './authService';

export const inquiriesService = {
  listInquiries: async () => {
    const response = await apiClient.get('/inquiries');
    return response.data;
  },
};
